import { ReactNode } from "react";

import { Props as TooltipProps, Tooltip } from "./Tooltip";

export interface TooltipDataItem {
  id?: string | number;
  label?: ReactNode;
  value: ReactNode;
}

interface Props extends Omit<TooltipProps, "content"> {
  items: TooltipDataItem[];
  mode?: string;
  title?: string;
}

export const DataTooltip = ({
  items,
  mode = "dark",
  title,
  children,
  ...props
}: Props) => {
  let content;
  if (mode == "dark") {
    content = (
      <div className="divide-y divide-chorus-gray-900 font-manrope text-xxs text-chorus-gray-300">
        {items.map((item) => (
          <p key={item.id} className="flex flex-col py-1 first:pt-0 last:pb-0">
            <strong className="font-bold leading-4 tracking-[0.24px]">
              {item.label}
            </strong>
            <span className="font-medium">{item.value}</span>
          </p>
        ))}
      </div>
    );
  } else {
    content = (
      <div className="relative ml-2 w-[396px] bg-white font-manrope text-xxs text-[#202239]">
        <div className="mt-3 font-manrope text-md font-semibold leading-5 tracking-[0.02em]">
          {title}
        </div>
        <hr className="my-2 border-chorus-gray-200" />
        {items.map((item) => (
          <div
            key={item.id}
            className="mt-3 flex flex-col py-1 first:pt-0 last:pb-0"
          >
            <div className="flex items-center">
              <strong className="mb-[0.5px] size-5 font-bold leading-4 tracking-[0.24px]">
                <img width={20} height={20} src={item.label?.toString()} />
              </strong>
              <div className="ml-1 text-sm font-superMedium">{item.id}</div>
            </div>
            <span className="mt-1 font-normal">{item.value}</span>
          </div>
        ))}
        <br />
      </div>
    );
  }

  return (
    <Tooltip
      content={content}
      stopClickPropagation={true}
      {...props}
      mode={mode}
    >
      {children}
    </Tooltip>
  );
};

DataTooltip.displayName = "DataTooltip";
